import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import React from "react";
import "./../index.scss";
import "./index.scss";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { InitiativeSlider } from "component/InitiativeList";
import { useEffect, useState } from "react";
import api from "api";
import _ from "lodash";
import {ReactComponent as SVGResearchIcon} from '../../../../assets/icon-research.svg';
import Breadcrumb from "component/Breadcrumb";
import { RoleDiscovery } from "component/RoleList";
import { PageCredential } from "component/PageCredential";

const PageBrowseTalent = (props) => {
    
    return (
        <>
            <Header/>
            <PageCredential title="Talent Initiatives"/>
            <div className="page-browse-brand">
                <div className="browse-brand-header bg-talent relative color-white">
                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['Talent Team']
                        ]}
                    />
                    <SVGResearchIcon className="brand-icon"/>
                    <div className="image-box image color-talent square">
                        <img src={`${process.env.PUBLIC_URL}/assets/image/bg/talent/header.jpg`} alt="" />
                        <div className="image-box square"></div>
                    </div>
                    <div className="">
                        <h1 className="text-lg bold">Talent Team</h1>
                        <div className="leading-text mt-4 text-sm">Build your dream team by finding the right talent for your project. Choose the talent that suitable with your needs based on their relevant qualifications, skills, and expertise.</div>
                    </div>
                </div>
                <div className="container">
                    <BlockHeader title="Recent Initiative" link={{
                        pathname : "browse"
                    }}/>
                    <InitiativeSlider initiatives_args={{
                        type : 'talent'
                    }} />
                </div>
                <div className="container">
                    <BlockHeader title="Available Roles" desc="Find out any role that might interest you" />
                    <RoleDiscovery role_args={{
                        name_not : 'General Member'
                        ,include_initiative__intiative_status : 'recruitment'
                        ,include_initiative__intiative_type : 'talent'
                    }} />
                </div>
            </div>

            <Footer/>
        </>
    )
}

export default PageBrowseTalent;